(function() {
  $(document).ready(function() {
    const body = document.querySelector('body'),
          productsArray = document.querySelectorAll('.product__wrapper'),
          header = document.querySelector('.header'),
          collectionList = document.querySelector('.collectionFullpage__list'),
          collectionSubcategories = document.querySelector('.collectionSubcategories'),
          noticeList = document.querySelector('.noticeList'),
          collectionHeader = document.querySelector('.collectionFullpage__titleWrapper');

    body.classList.add('body--active');

    productsArray.forEach((product, i) => {
      let delayTime = i / 10;

      product.style.opacity = 1;
      product.style.transitionDelay = `${delayTime}s`;
    });

    if (!collectionSubcategories) {
      const titleWrapper = document.querySelector('.collectionFullpage__titleWrapper');

      titleWrapper.classList.add('collectionFullpage__titleWrapper--noSubcategories');
    }

    if (window.innerWidth >= 769) {
      if (collectionList) {
        window.addEventListener('scroll', toggleHeader);
      }

      function toggleHeader() {
        if (collectionList.getBoundingClientRect().top - noticeList.offsetHeight <= 0) {
          header.classList.remove('header--animation');
        } else if (collectionList.getBoundingClientRect().top - header.offsetHeight - noticeList.offsetHeight <= 0) {
          header.classList.add('header--animation');
          collectionHeader.classList.add('collectionFullpage__titleWrapper--hidden');

          if (collectionSubcategories) {
            collectionSubcategories.classList.add('collectionSubcategories--hidden');
          }
        } else {
          header.classList.remove('header--animation');
          collectionHeader.classList.remove('collectionFullpage__titleWrapper--hidden');

          if (collectionSubcategories) {
            collectionSubcategories.classList.remove('collectionSubcategories--hidden');
          }
        }
      }
    }
  });
})();
